import React from "react";

interface CalendarIconProps {
  className?: string;
}

export const CalendarIcon = ({ className }: CalendarIconProps) => (
  <svg
    className={className}
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.3915 20H1.79894C1.32183 20 0.864265 19.7993 0.526898 19.4421C0.189531 19.0849 0 18.6004 0 18.0952V4.76192C0 4.25674 0.189531 3.77226 0.526898 3.41505C0.864265 3.05783 1.32183 2.85715 1.79894 2.85715H3.59788V0.952393H5.39683V2.85715H10.7937V0.952393H12.5926V2.85715H14.3915C14.8686 2.85715 15.3262 3.05783 15.6636 3.41505C16.0009 3.77226 16.1905 4.25674 16.1905 4.76192V18.0952C16.1905 18.6004 16.0009 19.0849 15.6636 19.4421C15.3262 19.7993 14.8686 20 14.3915 20ZM1.79894 8.57144V18.0952H14.3915V8.57144H1.79894ZM1.79894 4.76192V6.66668H14.3915V4.76192H1.79894ZM12.5926 16.1905H10.7937V14.2857H12.5926V16.1905ZM8.99471 16.1905H7.19577V14.2857H8.99471V16.1905ZM5.39683 16.1905H3.59788V14.2857H5.39683V16.1905ZM12.5926 12.381H10.7937V10.4762H12.5926V12.381ZM8.99471 12.381H7.19577V10.4762H8.99471V12.381ZM5.39683 12.381H3.59788V10.4762H5.39683V12.381Z" />
  </svg>
);

CalendarIcon.defaultProps = {
  className: "",
};
